import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import { defineComponent, ref, watch, onMounted, computed } from 'vue'; // import HetaoLogo from '@/assets/image/home/logo3.png';

import HetaoLogoWithoutBrand from '@/assets/image/home/logo5.png';
import HetaoLogoNoc from '@/assets/image/home/logo_noc.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue'; // import { environment } from '@/utils/environment';

import { useRouter, useRoute } from 'vue-router';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import LoginDialog from './LoginDialog.vue';
import GoToEnvCheckDialog from './GoToEnvCheckDialog.vue';
import { SHOW_BRAND, domains } from '@/utils';
export default defineComponent({
  name: 'HomeHeader',
  components: {
    LoginDialog: LoginDialog,
    GoToEnvCheckDialog: GoToEnvCheckDialog,
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function setup() {
    var selectedKeys = ref([]);
    var showCloseBtn = ref(true);
    var route = useRoute();
    setKeys(route);
    var router = useRouter();
    router.afterEach(function (to) {
      setKeys(to);
    });

    var clickMenuItem = function clickMenuItem(e) {
      var key2 = e.key;
      selectedKeys.value = [key2];
      router.push(key2);
    };

    function setKeys(to) {
      var path = to.path; // openKeys.value.push(path.slice(0, path.indexOf('/', 1)));

      selectedKeys.value = [path];
    }

    var userService = useService(UserService);
    var loginService = useService(LoginService);

    var logout = function logout() {
      userService.logout();
    };

    var goToUserCenter = function goToUserCenter() {
      router.push({
        name: 'UserItemList',
        query: route.query
      });
    };

    watch(function () {
      return userService.user;
    }, function (user) {
      enterValidate();

      if (!(user && user.userId)) {
        if (route.meta && route.meta.auth) {
          router.replace({
            name: 'Home'
          });
        }
      }
    });
    /**
     * ============================================
     * 需求：https://project.feishu.cn/ht-poject/story/detail/14341910
     * 需要根据活动id展示不同的HomeHeader，活动结束之后可删除
     */
    // const specialActiveList: any =
    //   environment === 'production' ? [855] : [209, 210];

    watch(function () {
      return route.name;
    }, function () {// let currentItemId = '';
      // if (visible === 'ItemDetail') {
      //   setTimeout(() => {
      //     const currentItemId = route.params.id as string;
      //     if (
      //       specialActiveList.includes(+currentItemId) &&
      //       !userService.user
      //     ) {
      //       loginService.showLoginDialog();
      //       showCloseBtn.value = false;
      //     }
      //   }, 500);
      // }
    }, {
      immediate: true
    }); // ============================================

    var enterValidate = function enterValidate() {
      if (!route.query.showLoginModal) return;

      if (!(userService.user && userService.user.userId)) {
        loginService.showLoginDialog();
        showCloseBtn.value = false;
      } else {
        loginService.hideLoginDialog();
      }
    };

    onMounted(function () {
      enterValidate();
    });
    var isNocFlag = computed(function () {
      return route.query.platform === 'noc';
    }); // 解决合肥投诉品牌事件 2024-03-21
    // const HetaoLogoFinal = SHOW_BRAND ? HetaoLogo : HetaoLogoWithoutBrand;

    var HetaoLogoFinal = isNocFlag.value ? HetaoLogoNoc : HetaoLogoWithoutBrand;
    return {
      HetaoLogoFinal: HetaoLogoFinal,
      selectedKeys: selectedKeys,
      clickMenuItem: clickMenuItem,
      loginService: loginService,
      userService: userService,
      logout: logout,
      goToUserCenter: goToUserCenter,
      SHOW_BRAND: SHOW_BRAND,
      domains: domains,
      showCloseBtn: showCloseBtn,
      isNocFlag: isNocFlag
    };
  }
});